import printJS from "print-js";
import { api_URL } from "./Constantes";

export const printBonpdf = (numba) => {
 
    const url = `${api_URL}/Print/Fournisseur/BC/${numba}?docName=CommandeFournDiv`;
   
    fetch(url, {
      method: 'GET',  
      
    })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      
      // Utilisez printJS pour imprimer le PDF
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };
  